import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, makeEntityChildrenIdsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import classnames from "classnames";
import Component, { type SocialIconsContainerProps } from "./component";
import { makeStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const itemsIdsSelector = makeEntityChildrenIdsSelector();
  const styleSelector = makeStyleSelector();
  const useBrandColorSelector = getSettingValueSelector(TargetSelector.Entity, "useBrandColor", "icon");

  return (state: AppState, props: RootContainerProps): SocialIconsContainerProps => {
    return {
      className: classnames("icons", {
        brand: useBrandColorSelector(state, props)
      }),
      itemsIds: itemsIdsSelector(state, props),
      style: styleSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
